// extracted by mini-css-extract-plugin
module.exports = {"ellipsis":"quote-items_ellipsis__uVjv7","removed":"quote-items_removed__QludY","added":"quote-items_added__n4FAN"};